import NFTPasses from "components/NFTPasses";
import NFTBuilderPasses from "components/NFTBuilderPasses";
import Banner from "components/Banner";
import Account from "components/Account";
import { Helmet } from "react-helmet";

function Homepage() {
  return (
    <div>
      <Helmet>
        <title>NFT Marketplace | NFT drop |  Member Pass - Web3 Texas </title>
        <meta name="description" content="Web3Texas offers the best NFT Marketplace in Texas. Here you can get exclusive NFT airdrops, crypto wallets, member passes, content contributor passes and more."></meta>
        <meta name="keywords" content="NFT Marketplace, Longhorn NFT Drop, NFT airdrop, Web3 Texas Team, Crypto wallet, member pass, Tokens, Community Builder Passes, Content Contributor Pass, Web3 Earth, Inc."></meta>
      </Helmet>
      <Banner />
      <Account />
      <NFTPasses />
      <NFTBuilderPasses />
    </div>
  );
}

export default Homepage;
